var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var WikiController = /** @class */ (function () {
    function WikiController() {
    }
    /*****************************************************************************************************
        * Is using route "api/wiki/category/{groupid}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @returns {WikiCategoryDownloadDto[]}
    ******************************************************************************************************/
    WikiController.GetWikiCategories = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/wiki/category/{groupid}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/wiki/Search" and http method "POST" to call the back-end.
    
        * @param {string} text
        * @param {string} lng
        * @param {FetchPostsFilter} filter
        * @returns {ExtendedDataCollection<WikiSearchResultDto, string>}
    ******************************************************************************************************/
    WikiController.Search = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("text", JSON.stringify(data.text));
        fd.append("lng", JSON.stringify(data.lng));
        if (data.filter !== undefined)
            fd.append("filter", JSON.stringify(data.filter));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/wiki/Search", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/wiki/ContinueSearch" and http method "POST" to call the back-end.
    
        * @param {TokenContainer} continuationTokenInput
        * @returns {ExtendedDataCollection<WikiSearchResultDto, string>}
    ******************************************************************************************************/
    WikiController.ContinueSearch = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("continuationTokenInput", JSON.stringify(data.continuationTokenInput));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/wiki/ContinueSearch", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/wiki/Suggest" and http method "POST" to call the back-end.
    
        * @param {string} term
        * @param {string} lng
        * @param {string[]} groupIds
        * @returns {string[]}
    ******************************************************************************************************/
    WikiController.SuggestTerm = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("term", JSON.stringify(data.term));
        fd.append("lng", JSON.stringify(data.lng));
        if (data.groupIds !== undefined)
            fd.append("groupIds", JSON.stringify(data.groupIds));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/wiki/Suggest", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/wiki/article/neighbors" and http method "POST" to call the back-end.
    
        * @param {WikiArticleDownloadDto} dto
        * @returns {WikiArticleDownloadDto[]}
    ******************************************************************************************************/
    WikiController.GetNeighbors = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/wiki/article/neighbors", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.dto
        });
    };
    /*****************************************************************************************************
        * Is using route "api/wiki/article/in/{id}/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {string} groupId
        * @returns {{ [key: string]: WikiArticleDownloadDto[]; }}
    ******************************************************************************************************/
    WikiController.GetArticlesInCatById = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/wiki/article/in/{id}/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/wiki/article/in/{catId}/{groupId}/{articleId1}/{articleId2}" and http method "POST" to call the back-end.
    
        * @param {string} catId
        * @param {string} groupId
        * @param {string} articleId1
        * @param {string} articleId2
        * @returns {{ [key: string]: WikiArticleDownloadDto[]; }}
    ******************************************************************************************************/
    WikiController.ReorderArticlesInCategory = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/wiki/article/in/{catId}/{groupId}/{articleId1}/{articleId2}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/wiki/groupById/{id}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @returns {string}
    ******************************************************************************************************/
    WikiController.GetGroupById = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/wiki/groupById/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/wiki/article" and http method "POST" to call the back-end.
    
        * @param {WikiArticleUploadDto} dto
        * @returns {WikiArticleDownloadDto}
    ******************************************************************************************************/
    WikiController.AddWikiArticle = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("dto", JSON.stringify(data.dto));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/wiki/article", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/wiki/article/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {WikiArticleUploadDto} dto
        * @returns {WikiArticleDownloadDto}
    ******************************************************************************************************/
    WikiController.UpdateWikiArticle = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("dto", JSON.stringify(data.dto));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/wiki/article/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/wiki/article/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    WikiController.DeleteWikiArticle = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/wiki/article/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/wiki/news" and http method "POST" to call the back-end.
    
        * @param {NewsPostUploadDto} dto
        * @param {File} mediaFile
        * @returns {NewsPostDownloadDto}
    ******************************************************************************************************/
    WikiController.PostWikiNews = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("dto", JSON.stringify(data.dto));
        if (data.mediaFile)
            fd.append("mediaFile", data.mediaFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/wiki/news", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/wiki/news/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {NewsPostUploadDto} dto
        * @param {File} mediaFile
        * @returns {NewsPostDownloadDto}
    ******************************************************************************************************/
    WikiController.PatchWikiNews = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("dto", JSON.stringify(data.dto));
        if (data.mediaFile)
            fd.append("mediaFile", data.mediaFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/wiki/news/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/wiki/news/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    WikiController.DeleteWikiNews = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/wiki/news/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/wiki/glossary" and http method "POST" to call the back-end.
    
        * @param {WikiGlossaryElementUploadDto} dto
        * @returns {WikiGlossaryElementDownloadDto}
    ******************************************************************************************************/
    WikiController.PostWikiGlossaryElement = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("dto", JSON.stringify(data.dto));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/wiki/glossary", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/wiki/glossary/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {WikiGlossaryElementUploadDto} dto
        * @returns {WikiGlossaryElementDownloadDto}
    ******************************************************************************************************/
    WikiController.PatchWikiGlossaryElement = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("dto", JSON.stringify(data.dto));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/wiki/glossary/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/wiki/glossary/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    WikiController.DeleteWikiGlossaryElement = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/wiki/glossary/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/wiki/glossary/{groupId}" and http method "GET" to call the back-end.
    
        * @param {string} groupId
        * @returns {WikiGlossaryElementDownloadDto[]}
    ******************************************************************************************************/
    WikiController.GetWikiGlossaryElements = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/wiki/glossary/{groupId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/wiki/getUploadUrl" and http method "POST" to call the back-end.
    
        * @param {string} mediaType
        * @param {string} fileName
        * @returns {UploadMediaParametersDto}
    ******************************************************************************************************/
    WikiController.GetUploadUri = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.mediaType !== undefined)
            fd.append("mediaType", JSON.stringify(data.mediaType));
        if (data.fileName !== undefined)
            fd.append("fileName", JSON.stringify(data.fileName));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/wiki/getUploadUrl", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    return WikiController;
}());
export { WikiController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=WikiController.js.map